import { render, staticRenderFns } from "./PublicityList.vue?vue&type=template&id=57df6fd2&scoped=true&"
import script from "./PublicityList.vue?vue&type=script&lang=js&"
export * from "./PublicityList.vue?vue&type=script&lang=js&"
import style0 from "./PublicityList.vue?vue&type=style&index=0&id=57df6fd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df6fd2",
  null
  
)

export default component.exports